import axios from "axios";
import { awsUrl, newApiBaseUrl } from "../../axiosInstance";
import * as actionType from "../store/action";
import showAlert from "./ShowAlert";
import { setPreload } from "./CartsOpen";
import { getCart } from "./CollectSite";

export const LogOut = () => {
  return (dispatch) => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("userRole");
    dispatch({ type: actionType.LOGOUT });
  };
};

export const loginPost = (isUser, password) => {
  return (dispatch) => {
    axios
      .get(`${newApiBaseUrl}/users/me/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
          "X-Tenant": "hamazon",
        },
      })
      .then((x) => {
        const roles = JSON.parse(localStorage.getItem("userRole")) || [];
        dispatch({
          type: actionType.LOGIN,
          payload: {
            user: x.data,
            role: roles?.some(
              (role) => role !== "customer" && role !== "guest",
            ),
            stationId: x.data.defaultLocation,
          },
        });
      })

      .catch(() => {
        localStorage.removeItem("jwtToken");
        if (isUser) {
          showAlert({ msgTitle: "שם משתמש וסיסמה שגויים", msgType: "error" });
        }
      });
  };
};
export const PutCustomer = (data) => {
  return (dispatch) => {
    axios
      .put(`${awsUrl}/v1/customers`, data, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        dispatch({
          type: actionType.LOGIN,
          payload: {
            user: x.data,
            role: false,
            stationId: x.data.StationId,
          },
        });
      })
      .finally((c) => dispatch(setPreload(false)));
  };
};

export const UpdateCustomerStationId = (customerId, stationId) => {
  return (dispatch) => {
    const tryUpdate = async () => {
      while (true) {
        try {
          await axios.put(
            `${awsUrl}/v1/customers`,
            { StationId: stationId },
            {
              headers: {
                Authorization: `bearer ${localStorage.jwtToken}`,
              },
            },
          );

          await updateToken(stationId);

          dispatch({
            type: actionType.UPDATE_STATION_ID,
            payload: stationId,
          });
          dispatch(getCart(stationId));
          break;
        } catch (error) {
          if (
            error.response &&
            error.response.data?.error &&
            error.response.data.error.includes("Deadlock")
          ) {
            console.warn("Deadlock detected, retrying in 1 second...");
            await new Promise((res) => setTimeout(res, 1000));
          } else {
            if (error.response) {
              console.error(
                "Server responded with:",
                error.response.status,
                error.response.data,
              );
            } else {
              console.error("Error updating Station ID:", error.message);
            }
            break;
          }
        } finally {
          dispatch(setPreload(false));
        }
      }
    };
    tryUpdate();
  };
};

export const sendVerifiedMail = (token) => {
  return (dispatch) => {
    dispatch(setPreload(true));
    const jwtToken = localStorage.getItem("jwtToken");

    if (!jwtToken) {
      showAlert({
        msgTitle: "פג תוקף ההתחברות, יש להתחבר מחדש",
        msgType: "error",
      });
      dispatch(setPreload(false));
      return Promise.reject(new Error("Missing jwtToken"));
    }

    return axios
      .post(
        `${newApiBaseUrl}/users/me/email-verification/verify`,
        { validationCode: token },
        {
          headers: {
            "x-tenant": "hamazon",
            Authorization: `Bearer ${jwtToken}`,
          },
        },
      )
      .then((res) => {
        // We already have a JWT (from registration), so hydrate app user state
        // without showing the login dialog again.
        dispatch(loginPost(false));
        return res;
      })
      .catch((err) => {
        const status = err.response?.status;
        const msgTitle =
          status === 401 || status === 403
            ? "פג תוקף ההתחברות, יש להתחבר מחדש"
            : status === 400
              ? "קוד אימות שגוי"
              : "אירעה שגיאה, נא לנסות שוב";

        showAlert({ msgTitle, msgType: "error" });
        throw err;
      })
      .finally(() => dispatch(setPreload(false)));
  };
};

export const resendVerificationEmail = () => {
  return (dispatch) => {
    dispatch(setPreload(true));
    const jwtToken = localStorage.getItem("jwtToken");

    if (!jwtToken) {
      showAlert({
        msgTitle: "פג תוקף ההתחברות, יש להתחבר מחדש",
        msgType: "error",
      });
      dispatch(setPreload(false));
      return Promise.reject(new Error("Missing jwtToken"));
    }

    return axios
      .post(
        `${newApiBaseUrl}/users/me/email-verification/resend`,
        {},
        {
          headers: {
            "x-tenant": "hamazon",
            Authorization: `Bearer ${jwtToken}`,
          },
        },
      )
      .then((res) => {
        showAlert({
          msgTitle: "נשלח קוד אימות חדש למייל",
          msgType: "success",
        });
        return res;
      })
      .catch((err) => {
        const status = err.response?.status;
        const msgTitle =
          status === 401 || status === 403
            ? "פג תוקף ההתחברות, יש להתחבר מחדש"
            : "אירעה שגיאה בשליחת קוד חדש, נא לנסות שוב";
        showAlert({ msgTitle, msgType: "error" });
        throw err;
      })
      .finally(() => dispatch(setPreload(false)));
  };
};

export const loginToken = (data, isUser) => {
  return async (dispatch) => {
    try {
      const awsResponse = await axios.post(
        `${newApiBaseUrl}/auth/login`,
        {
          username: data.userName,
          password: data.password,
        },
        { headers: { "x-tenant": "hamazon" } },
      );

      localStorage.setItem("jwtToken", awsResponse.data.jwt);
      localStorage.setItem(
        "userRole",
        JSON.stringify(awsResponse.data.roles || []),
      );

      if (isUser && awsResponse.data.emailVerified === false) {
        dispatch(resendVerificationEmail()).then(() => {
          dispatch({
            type: actionType.VERIFIED_EMAIL,
            payload: {
              customerId: awsResponse.data.userId,
              email: data.userName,
              password: data.password,
              passwordMail: null,
            },
          });
        }).catch(() => {
          console.log("Failed to resend verification email, but proceeding to login flow anyway.");
        });
        return awsResponse.data.jwt;
      }

      dispatch(loginPost(isUser, data.password));
      return awsResponse.data.jwt;
    } catch (error) {
      const errorMessage =
        error.response?.status === 401 ? "שם משתמש וסיסמה שגויים" : "שגיאה";
      showAlert({ msgTitle: errorMessage, msgType: "error" });
      throw error;
    }
  };
};

export const customerRegister = (val) => {
  return (dispatch) => {
    dispatch(setPreload(true));
    axios
      .post(
        `${newApiBaseUrl}/users/customer`,
        {
          email: val.email,
          password: val.password,
          firstName: val.firstName,
          lastName: val.lastName,
          phone: val.phone,
          username: val.email,
          tenant: "hamazon",
          defaultLocation: "678430",
          addrStreet: val.addrStreet,
          addrHouse: val.addrHouse,
          addrFloor: val.addrFloor,
          addrApartment: val.addrApartment,
          addrZipCode: val.addrZipCode,
        },
        { headers: { "x-tenant": "hamazon" } },
      )
      .then((x) => {
        if (x.data?.jwt) {
          localStorage.setItem("jwtToken", x.data.jwt);
        }
        if (x.data?.roles) {
          localStorage.setItem("userRole", JSON.stringify(x.data.roles));
        } else {
          // Prevent fallback guest UI when backend omits roles in register response.
          localStorage.setItem("userRole", JSON.stringify(["customer"]));
        }
        dispatch({
          type: actionType.VERIFIED_EMAIL,
          payload: {
            customerId: x.data.userId,
            email: val.email,
            password: val.password,
            passwordMail: x.data.Name,
          },
        });
        showAlert({
          msgTitle: "נרשמת בהצלחה! קוד אימות נשלח למייל שלך",
          msgType: "success",
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 409) {
          showAlert({
            msgTitle: "כתובת המייל כבר קיימת במערכת",
            msgType: "error",
          });
        } else {
          showAlert({
            msgTitle: err.response?.data?.Message || "שגיאה ברישום",
          });
        }
      })
      .finally(() => dispatch(setPreload(false)));
  };
};

export const sendPasswordPgw = async (email) => {
  try {
    const res = await axios.post(
      `${newApiBaseUrl}/auth/password-reset/request`,
      { email: email, tenant: "hamazon" },
      { headers: { "x-tenant": "hamazon" } },
    );
    showAlert({ msgTitle: "נשלח לך מייל", msgType: "success" });
    return res.data;
  } catch (err) {
    showAlert({
      msgTitle: "לא מצאנו את כתובת המייל במערכת",
      msgType: "error",
    });
    throw err;
  }
};

export const ChangPassword = (data) => {
  return (dispatch) => {
    dispatch(setPreload(true));
    axios
      .post(`${awsUrl}/v1/changePassword`, data)
      .then((x) => {
        if (x.data) {
          showAlert({ msgTitle: "הסיסמה עודכנה בהצלחה", msgType: "success" });
        } else {
          throw new Error();
        }
      })
      .catch((err) =>
        showAlert({ msgTitle: "קוד האיפוס אינו תקין", msgType: "error" }),
      )
      .finally(() => dispatch(setPreload(false)));
  };
};

export const setUserEntry = (value) => {
  return (dispatch) =>
    dispatch({ type: actionType.USER_ENTRY, payload: value });
};

export const updateStationId = (value) => {
  return (dispatch) =>
    dispatch({ type: actionType.UPDATE_STATION_ID, payload: value });
};

export const getAllCustomer = (stationId) => {
  return axios.get(`${newApiBaseUrl}/users`, {
    params: { stationId: "678430" },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const updateToken = async (stationId) => {
  try {
    const awsResponse = await axios.put(
      `${awsUrl}/v1/user/token`,
      { stationId },
      {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      },
    );
    if (awsResponse.data.access_token)
      localStorage.setItem("jwtToken", awsResponse.data.access_token);
  } catch (error) {
    // Show error alert if either request fails
    const errorMessage =
      error.response?.status === 404 ? "תחנה שגויה" : "שגיאה";
    showAlert({ msgTitle: errorMessage, msgType: "error" });
  }
  return;
};
export const UpdateUser = (updatedData) => {
  return axios.put(`${newApiBaseUrl}/users/me/profile`, updatedData, {
    headers: {
      "Content-Type": "application/json",
      "x-tenant": "hamazon",
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const sendPasswordVerify = async (validationCode, userId) => {
  try {
    const res = await axios.post(
      `${newApiBaseUrl}/auth/password-reset/verify`,
      { validationCode, userId },
      {
        headers: {
          "x-tenant": "hamazon",
          "Content-Type": "application/json",
        },
      },
    );
    return res.data;
  } catch (err) {
    showAlert({ msgTitle: "קוד האיפוס אינו תקין", msgType: "error" });
    throw err;
  }
};

export const confirmPasswordReset = async (
  userId,
  validationCode,
  newPassword,
) => {
  try {
    const res = await axios.post(
      `${newApiBaseUrl}/auth/password-reset/confirm`,
      {
        userId,
        validationCode,
        newPassword,
      },
      {
        headers: {
          "x-tenant": "hamazon",
          "Content-Type": "application/json",
        },
      },
    );

    return res.data;
  } catch (err) {
    showAlert({ msgTitle: "משהו השתבש", msgType: "error" });
    throw err;
  }
};